import { render } from "./UiQuantity.vue?vue&type=template&id=202a662b&ts=true&lang=pug"
import script from "./UiQuantity.vue?vue&type=script&setup=true&lang=ts"
export * from "./UiQuantity.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__